import { Component, Prop, Vue } from 'vue-property-decorator';
import { Emit } from 'vue-property-decorator';
import './numeric-keyboard.component.scss';

@Component({})
export default class NumericKeyboard extends Vue {
  @Prop() acceptText!: string;
  @Emit()
  buttonHandle(e: Event): void {
    const obj = e.target as HTMLButtonElement;
    this.$emit('numberHandle', obj.innerText);
  }
  @Emit()
  backBtn(): void {
    this.$emit('backBtn');
  }
  @Emit()
  moveBtn(): void {
    this.$emit('moveBtn');
  }
  @Emit()
  deleteBtn(): void {
    this.$emit('deleteBtn');
  }
  @Emit()
  acceptBtn(): void {
    this.$emit('acceptBtn');
  }
  render() {
    return (
      <b-container class="number-keyboard d-flex flex-column justify-content-center">
        <div class="calc-button-row">
          <button class="calc-button" onClick={() => this.backBtn()}>
            <span class="material-icons md-dark align-middle cursor-pointer font-weight-bold">arrow_back</span>
          </button>
          <button class="calc-button align-items-center" onClick={() => this.moveBtn()}>
            <span class="material-icons md-dark align-middle cursor-pointer font-weight-bold">arrow_forward</span>
          </button>
          <button class="calc-button del" onClick={() => this.deleteBtn()}>
            <span class="icon icon-clean-svg align-middle cursor-pointer"></span> &nbsp;1文字
          </button>
        </div>
        <div class="calc-button-row">
          <button class="calc-button" onClick={(e: Event) => this.buttonHandle(e)}>
            7
          </button>
          <button class="calc-button" onClick={(e: Event) => this.buttonHandle(e)}>
            8
          </button>
          <button class="calc-button" onClick={(e: Event) => this.buttonHandle(e)}>
            9
          </button>
        </div>
        <div class="calc-button-row">
          <button class="calc-button" onClick={(e: Event) => this.buttonHandle(e)}>
            4
          </button>
          <button class="calc-button" onClick={(e: Event) => this.buttonHandle(e)}>
            5
          </button>
          <button class="calc-button" onClick={(e: Event) => this.buttonHandle(e)}>
            6
          </button>
        </div>
        <div class="calc-button-row">
          <button class="calc-button" onClick={(e: Event) => this.buttonHandle(e)}>
            1
          </button>
          <button class="calc-button" onClick={(e: Event) => this.buttonHandle(e)}>
            2
          </button>
          <button class="calc-button" onClick={(e: Event) => this.buttonHandle(e)}>
            3
          </button>
        </div>
        <div class="calc-button-row mb-1 pb-3">
          <button class="calc-button zero-btn" onClick={(e: Event) => this.buttonHandle(e)}>
            0
          </button>
          <button id="accept-btn" class="calc-button accept-btn triple" on-click={() => this.acceptBtn()}>
            {this.acceptText ? this.acceptText : '発進'}
          </button>
        </div>
      </b-container>
    );
  }
}
